import { SplashScreen } from '@capacitor/splash-screen';
import { isNative } from './platform';

/**
 * The native splash stays up until the app has drawn its first real screen (capacitor.config.ts sets
 * launchAutoHide: false). A missed call would leave the app stuck behind it, so a timer hides it
 * anyway after FALLBACK_MS.
 */
const FALLBACK_MS = 3000;

let hidden = false;

export const hideSplash = (): void => {
    if (hidden || !isNative()) return;
    hidden = true;
    console.info(`[splash] hidden t=${Math.round(performance.now())}`);
    SplashScreen.hide().catch((error) => console.error('[splash] hide failed:', error));
};

export const scheduleSplashFallback = (): void => {
    setTimeout(hideSplash, FALLBACK_MS);
};
